const calculationHelper = class CalculationHelper {
  // Old calculations helpers
  // static convertInPixel (value) {
  //   return (window.innerHeight / 100) * value
  // }
  // static calculateCircumference (radius) {
  //   return 2 * Math.PI * radius
  // }
  //
  // static calculateMaxItems (circumference, itemSize) {
  //   itemSize = this.convertInPixel(itemSize)
  //   return Math.floor(circumference / itemSize)
  // }

  static calculateDefaultAngle (itemsCount) {
    return 360 / itemsCount
  }

  static calculateRotation (angle, index) { // Angle?
    return angle * index
  }

  static calculateSkewY (angle, offset = 0) { // Angle?
    return angle + 90 - offset
  }

  static calculateExpandedSkewY (angle, offset = 0) {
    return this.calculateSkewY(angle * 2, offset)
  }

  static calculateAverage (a, b) {
    return (a + b) / 2
  }
}

export default calculationHelper
